module.exports = __webpack_public_path__ + "static/dija_logo-201f98c8ab97246161b3a89f04dc61da.png";